//@ts-check
import { openFailedDialog, openInfoDialog } from '@/common/components/kf-dialog';
import { hideLoading, showLoading } from '@/common/components/kf-loader';
import { STATUS_FAILURE_CTR_PCCOUNT, STATUS_FAILURE_IDPASSWORD, STATUS_FAILURE_NO_OFFICE, STATUS_FAILURE_PCMAIN_NOTREGISTER } from '@/common/constants';
import createBatchAction from '@/common/lib/create-batch-action';
import { errorHandler } from '../ajax';

export const pcCheckErrorHandler = (err) => {
  switch (err.status) {
    case STATUS_FAILURE_NO_OFFICE:
    case STATUS_FAILURE_IDPASSWORD:
      return openFailedDialog('事業所IDかAPIキーが一致しません。');
    case STATUS_FAILURE_CTR_PCCOUNT:
      return openFailedDialog('台数の制限を超えています。');
    case STATUS_FAILURE_PCMAIN_NOTREGISTER:
      return openInfoDialog('PCの登録が必要です。');
    default:
      return errorHandler(err);
  }
};

const pcRegisterErrorHandler = (err) => {
  switch (err.status) {
    case STATUS_FAILURE_NO_OFFICE:
    case STATUS_FAILURE_IDPASSWORD:
      return openFailedDialog('事業所IDかAPIキーが一致しません。');
    default:
      return errorHandler(err);
  }
};


export const pcCheckRequest = createBatchAction('@@pc/PC_CHECK_REQUEST', () => [showLoading()]);
export const pcCheckSuccess = createBatchAction('@@pc/PC_CHECK_SUCCESS', () => [hideLoading()]);
export const pcCheckFailure = createBatchAction('@@pc/PC_CHECK_FAILURE', (err) => [
  hideLoading(),
  pcCheckErrorHandler(err)
]);

export const pcRegisterRequest = createBatchAction('@@pc/PC_REGISTER_REQUEST', () => [showLoading()]);
export const pcRegisterSuccess = createBatchAction('@@pc/PC_REGISTER_SUCCESS', () => [
  hideLoading()
]);
export const pcRegisterFailure = createBatchAction('@@pc/PC_REGISTER_FAILURE', (err) => [
  hideLoading(),
  pcRegisterErrorHandler(err)
]);